import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { Container, Form, Button, Alert, Spinner } from 'react-bootstrap';
import AuthNavbar from '../navbars/AuthNavbar';
import axios from 'axios';

function ResetPasswordPage() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            setError('Chýbajúci alebo neplatný token.');
        }
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            setError('Heslá sa nezhodujú.');
            return;
        }

        setIsSubmitting(true);
        try {
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth/reset-password`, {
                token,
                new_password: newPassword
            });
            setMessage('Heslo bolo úspešne zmenené. Môžeš sa prihlásiť.');
            setError(null);
            setTimeout(() => navigate('/login', { state: { msg: 'Heslo bolo zmenené. Prihlás sa.' } }), 3000);
        } catch (err) {
            setError(err.response?.data?.detail || 'Chyba pri zmene hesla.');
            setMessage(null);
        }
        setIsSubmitting(false);
    };

    return (
        <>
            <AuthNavbar />
            <Container className="mt-4">
                <h2 className="text-center">Zmena hesla</h2>
                {message && <Alert variant="success">{message}</Alert>}
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Nové heslo</Form.Label>
                        <Form.Control
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Potvrď nové heslo</Form.Label>
                        <Form.Control
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Button type="submit" className="w-100" disabled={isSubmitting || !token}>
                        {isSubmitting && <Spinner as="span" size="sm" className="me-2" />}
                        Zmeniť heslo
                    </Button>
                </Form>

                <div className="d-flex justify-content-between mt-3">
                    <Link to="/login">Späť na prihlásenie</Link>
                </div>
            </Container>
        </>
    );
}

export default ResetPasswordPage;
